module.exports = __webpack_public_path__ + "img/result-bg.6a816e3a.png";